
import { mapState, mapMutations, mapActions } from 'vuex'

import Icon from '../../../common/Icon'

export default {
  name: 'VehicleInfo',
  components: { Icon },
  mounted() {
    if (this.cart && this.cart.custom && !this.vehicleInfo) {
      const makeObj = this.cart.custom.find(custom => custom.label.toLowerCase() == 'make')
      const make = makeObj ? makeObj.value : ''
      const modelObj = this.cart.custom.find(custom => custom.label.toLowerCase() == 'model')
      const model = modelObj ? modelObj.value : ''
      const colorObj = this.cart.custom.find(custom => custom.label.toLowerCase() == 'color')
      const color = colorObj ? colorObj.value : ''
      
      if (make && model && color) {
        this.setVehicleInfo({ make, model, color })
      }
    }
  },
  computed: {
    ...mapState([ 'cart' ]),
    ...mapState({
      vehicleInfo: state => state.locations.vehicleInfo
    }),
    isCateringPage() {
      return this.$route.fullPath.includes('catering')
    },
  },
  methods: {
    ...mapActions(['hideCart']),
    ...mapMutations({
      setVehicleInfo: 'locations/setVehicleInfo',
    }),
    redirectToLocationSearch() {
      document.body.style.overflow = 'auto'
      this.hideCart();
      this.$router.push(this.isCateringPage ? '/catering' : '/locations')
    },
  }
}
